<sl-label size="large" i18n>Accounting</sl-label>

<form [formGroup]="form" *ngIf="isInitialized() && form">
    <sl-well padding>
        <sl-list>
            <sl-list-item center>
                <sl-label size="small" i18n="@@AccountingView.Accounting">Accounting</sl-label>
                <sl-switch slot="suffix" [(ngModel)]="enabled" [ngModelOptions]="{standalone:true}"></sl-switch>
            </sl-list-item>
        </sl-list>
    </sl-well>
    
    <sl-label class="mt-6" i18n="@@AccountingView.Connection">Connection</sl-label>
    <sl-well padding>
        <sl-list>
            <sl-list-item center>
                <sl-label *ngIf="!isSystemDefined()" size="small" i18n="@@AccountingView.NotConnected">Not connected</sl-label>
                <sl-label *ngIf="isSystemDefined()" size="small">
                    <span i18n="@@AccountingView.Connected">Connected to {{form.value.system}}</span>
                    <sl-badge *ngIf="isSystemUnableToConnect() && !checkingConnection" class="ml-3" type="warning"><sl-icon name="exclamation-circle" slot="suffix"></sl-icon> <span i18n>Unable to connect</span></sl-badge>
                </sl-label>
                
                <sl-button *ngIf="!checkingConnection && !isSystemDefined()" [disabled]="!enabled" slot="suffix" size="small" (click)="connectSystem()" i18n="@@AccountingView.ConnectToSystem">Connect to system...</sl-button>
                <sl-button *ngIf="!checkingConnection && isSystemDefined() && !isSystemUnableToConnect()" [disabled]="!enabled" slot="suffix" size="small" (click)="disconnectSystem()" i18n="@@AccountingView.Disconnect">Disconnect</sl-button>
                <sl-button *ngIf="!checkingConnection && isSystemDefined() && isSystemUnableToConnect()" type="primary" [disabled]="!enabled" slot="suffix" size="small" (click)="reconnectSystem()" i18n="@@AccountingView.Reconnect">Reconnect</sl-button>
                <sl-spinner class="my-3" *ngIf="checkingConnection" slot="suffix"></sl-spinner>
            </sl-list-item>
        </sl-list>
    </sl-well>

    <sl-label class="mt-6" i18n="@@AccountingView.Settings">Settings</sl-label>
    <sl-well padding>
        <sl-list>
            <sl-list-item center>
                <sl-label size="small" i18n="@@AccountingView.InvoiceCreation">Invoice Creation</sl-label>
                <sl-select slot="suffix" hoist size="small" formControlName="accountingMode">
                    <sl-menu-item value="None" i18n>None</sl-menu-item>
                    <sl-menu-item value="AddToDraft" i18n>Create draft Invoice for assignments</sl-menu-item>
                    <sl-menu-item value="AddToInvoice" i18n>Create posted Invoice for assignments</sl-menu-item>
                </sl-select>
            </sl-list-item>
            <sl-list-item center>
                <sl-label size="small" i18n="@@AccountingView.InvoiceTime">Invoice Time</sl-label>
                <sl-select slot="suffix" hoist size="small" formControlName="accountingTime">
                    <sl-menu-item value="BeforeWork" i18n>At night before</sl-menu-item>
                    <sl-menu-item value="AfterWork" i18n>When work is completed</sl-menu-item>
                </sl-select>
            </sl-list-item>
            <sl-list-item center>
                <sl-label size="small" i18n="@@AccountingView.InvoiceDelivery">Invoice Delivery</sl-label>
                <sl-select slot="suffix" hoist size="small" formControlName="invoiceDelivery">
                    <sl-menu-item value="None" i18n>None</sl-menu-item>
                    <sl-menu-item value="Email" i18n>Send by Email</sl-menu-item>
                </sl-select>
            </sl-list-item>
        </sl-list>
    </sl-well>
</form>
